/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
import { parcoursTypes } from '../../../../helpers/utils';
import { toastSuccess, toastError, toastWarning } from '../../../../redux/actions/alertActions';
import companyServices from '../../../../redux/services/companyServices';
import elearningServices from '../../../../redux/services/elearningServices';
import groupServices from '../../../../redux/services/groupServices';

const useSemester = (companyId, semestersData, setSemestersData, type) => {
  const handleNumber = (val) => {
    const isnum = /^\d+$/.test(val);
    if (isnum) {
      return false;
    }
    return true;
  };

  const addSemester = (form, needFormer) => {
    const tmpBegin = new Date(form.beginDate);
    const tmpEnd = new Date(form.endDate);
    tmpBegin.setHours(15);
    tmpEnd.setHours(15);
    const semesterObj = {
      semester: parcoursTypes.includes(type) ? 0 : form.semester.value,
      elearningHours: form.elearningHours ? parseFloat(form.elearningHours) * 60 : 0,
      presentialGroups: form.presentialGroups ? parseInt(form.presentialGroups, 10) : 0,
      presentialHours: form.presentialHours ? parseFloat(form.presentialHours) * 60 : 0,
      needFormer,
      beginDate: tmpBegin,
      endDate: tmpEnd,
      catchUpDate: form.catchUpDate,
      referents: form.referents,
    };
    if (handleNumber(semesterObj.elearningHours)
        || handleNumber(semesterObj.presentialGroups)
        || handleNumber(semesterObj.presentialHours)) {
      toastError('Valeurs incorrectes');
      return;
    }
    if (semesterObj.semester === undefined) {
      toastError('Aucun semestre n\'a été sélectionné');
      return;
    }
    if (semesterObj.elearningHours === 0 && semesterObj.presentialGroups === 0 && semesterObj.presentialHours === 0) {
      toastWarning('Attention, aucune heure d\'e-learning ou de présentiel n\'a été rentrée');
    }
    if (semesterObj.beginDate === null
          || semesterObj.beginDate === undefined) {
      toastError('Date de début incorrecte');
      return;
    }
    if (semesterObj.endDate === null
          || semesterObj.beginDate === undefined) {
      toastError('Date de fin incorrecte');
      return;
    }
    if (semesterObj.endDate < semesterObj.beginDate) {
      toastError('La date de début ne doit pas être après la date de fin');
      return;
    }
    if (needFormer && (semesterObj.presentialGroups === null || semesterObj.presentialHours === null)) {
      toastError('Informations manquantes');
      return;
    }
    companyServices.updateCompanySemesters(companyId, [...semestersData, semesterObj])
      .then((res) => {
        setSemestersData(res.semesters);
        toastSuccess('Informations du semestre ajoutées.');
      })
      .catch(() => {
        toastError('Problème lors de la mise à jour des semestres.');
      });
  };

  const updateSemester = (newData, name) => {
    let semesterObj;
    if (name === 'updateSemester') {
      const tmpBegin = new Date(newData.beginDate);
      const tmpEnd = new Date(newData.endDate);
      tmpBegin.setHours(15);
      tmpEnd.setHours(15);
      if (!newData.semester || !newData.semester.value) {
        toastError('Erreur lors de la modification du semestre, veuillez réessayer.');
        return;
      }
      semesterObj = {
        _id: newData._id,
        semester: newData.semester.value,
        elearningHours: (newData.elearningHours || newData.elearningMinutes) ? parseFloat(newData.elearningHours || 0) * 60 + parseFloat(newData.elearningMinutes || 0) : 0,
        presentialGroups: parseInt(newData.presentialGroups, 10),
        presentialHours: (newData.presentialHours || newData.presentialMinutes) ? parseFloat(newData.presentialHours || 0) * 60 + parseFloat(newData.presentialMinutes || 0) : 0,
        needFormer: newData.needFormer,
        beginDate: tmpBegin,
        referents: newData.referents,
        endDate: tmpEnd,
        catchUpDate: newData.catchUpDate,
        ponderation: newData.ponderation ? newData.ponderation : null,
      };
    } else if (name === 'updatePonderation') {
      semesterObj = {
        _id: newData._id,
        semester: newData.semester,
        elearningHours: newData.elearningHours,
        presentialGroups: newData.presentialGroups,
        presentialHours: newData.presentialHours,
        needFormer: newData.needFormer,
        beginDate: newData.beginDate,
        referents: newData.referents,
        endDate: newData.endDate,
        catchUpDate: newData.catchUpDate,
        ponderation: newData.ponderation,
      };
    }
    const updatedSemestersArr = [...semestersData];
    updatedSemestersArr.forEach((semesterItem, index) => {
      if (semesterObj.semester === semesterItem.semester) {
        updatedSemestersArr.splice(index, 1, semesterObj);
      }
    });
    companyServices.updateCompanySemesters(companyId, updatedSemestersArr)
      .then((res) => {
        toastSuccess('Informations du semestre ajoutées.');
        groupServices.getGroupByCompanyList(companyId)
          .then((groups) => {
            const groupArr = Object.values(groups.data);
            const _groups = [];
            for (let i = 0; groupArr[i]; i += 1) {
              if (groupArr[i].semester === semesterObj.semester) {
                _groups.push(groupArr[i]);
              }
            }
            if (_groups.length === 0) {
              toastError('Aucun contenu n\'a été attribué pour ce semestre, veuillez contacter l\'assistance Médical World.');
              return;
            }
            if (name === 'updateSemester') {
              _groups.forEach(async (_group, index) => {
                const tmpGroup = _group;
                tmpGroup.elearning.elearningDuration = (newData.elearningHours || newData.elearningMinutes) ? parseFloat(newData.elearningHours || 0) * 60 + parseFloat(newData.elearningMinutes || 0) : 0;
                tmpGroup.elearning.presentialHours = (newData.presentialHours || newData.presentialMinutes) ? parseFloat(newData.presentialHours || 0) * 60 + parseFloat(newData.presentialMinutes || 0) : 0;
                await elearningServices.updateElearningDetails(tmpGroup.elearning._id, tmpGroup.elearning)
                  .then(() => {
                    groupServices.getGroupByCompanyList(companyId)
                      .then(() => {
                        if (index === _groups.length - 1) {
                          setSemestersData(res.semesters.sort((a, b) => a.semester - b.semester));
                        }
                      });
                  });
              });
            } else {
              groupServices.getGroupByCompanyList(companyId)
                .then(() => {
                  setSemestersData(res.semesters.sort((a, b) => a.semester - b.semester));
                });
            }
          });
      })
      .catch(() => {
        toastError('Problème lors de la mise à jour des semestres.');
      });
  };

  const deleteSemester = (_id) => {
    const res = [];
    semestersData.forEach((data) => {
      if (data._id !== _id) {
        res.push(data);
      }
    });
    companyServices.updateCompanySemesters(companyId, res)
      .then((_res) => {
        setSemestersData(_res.semesters.sort((a, b) => a.semester - b.semester));
        toastSuccess('Semestres mis à jour.');
      })
      .catch((err) => {
        if (err) {
          toastError('Problème lors de la suppression du semestre.');
        }
      });
  };

  const updateCompanyDataPonderation = (switchBool) => {
    companyServices.updateCompanyDataPonderation(companyId, switchBool)
      .then(() => {
        if (switchBool === true) {
          toastSuccess('Pondération activée.');
        } else {
          toastSuccess('Pondération désactivée.');
        }
      })
      .catch((err) => {
        if (err) {
          toastError('Problème lors de la mise à jour du semestre.');
        }
      });
  };

  return {
    addSemester,
    updateSemester,
    deleteSemester,
    handleNumber,
    updateCompanyDataPonderation,
  };
};

export default useSemester;
